import { render, staticRenderFns } from "./addStaff.vue?vue&type=template&id=03e12e2b&scoped=true"
import script from "./addStaff.vue?vue&type=script&lang=js"
export * from "./addStaff.vue?vue&type=script&lang=js"
import style0 from "./addStaff.vue?vue&type=style&index=0&id=03e12e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e12e2b",
  null
  
)

export default component.exports